<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            title="UPDATE CURRENCY"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-incoterms-popup" @submit.prevent="handleSubmit(onClickUpdateCurrency)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name/Code</small>
                <vs-input disabled :value="`${form.name} - ${form.code}`" name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="fx_value" name="fx_value" rules="required" v-slot="{ errors }">
                <small class="label">Fx Value</small>
                <vs-input v-model="form.fx_value"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-currency-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form.fx_value = ''" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const IncotermRepository = RepositoryFactory.get('incoterm');
  const CcpRepository = RepositoryFactory.get('ccp');
  const SettingsRepository = RepositoryFactory.get('settings');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
    }
  }

  export default {
    name: 'UpdateCurrencyPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(currency_data) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          Object.assign(this.form, currency_data)
        } catch (error) {

        }
      },
      async fetchIncotermDetails() {
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          const {data} = (await CcpRepository.getCcp(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
      async onClickUpdateCurrency() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          await SettingsRepository.updateCurrency(this.form.id, { fx_value: this.form.fx_value });
          this.showSuccessMessage('Currency fx value updated!');
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
